export enum EViews {
  CASES = "CASES",
  ACTIONS = "ACTIONS",
  EVENTS = "EVENTS",
  CLIENTS = "CLIENTS",
  LETTERS = "LETTERS",
  PACKAGES_INCOMING = "PACKAGES_INCOMING",
  PACKAGES_OUTCOMING = "PACKAGES_OUTCOMING",
  TEMPLATES = "TEMPLATES",
  FOLDERS = "FOLDERS",
  INVOICES = "INVOICES",
  ENGAGEMENTS = "ENGAGEMENTS",
}
